import { useState } from "react";

const sel = "w-full text-xs border border-brand-border rounded px-2 py-1.5 bg-brand-page text-brand-ink outline-none";

export function QuickAddTask({ colName, ctx, onSubmit, onCancel }) {
  const [title, setTitle] = useState("");
  const [office, setOffice] = useState("");
  const [person, setPerson] = useState("");
  const [due, setDue] = useState("");
  const { meta, users = [], offices = [] } = ctx || {};

  const submit = () => {
    if (!title.trim()) return;
    onSubmit(colName, title.trim(), {
      office_ids: office ? [office] : undefined,
      assignee_ids: person ? [person] : undefined,
      due: due || undefined,
    });
  };

  return (
    <div className="bg-brand-surface border border-brand-border rounded-lg p-2 space-y-2" data-testid={`quick-add-${colName}`}>
      <textarea autoFocus value={title} onChange={(e) => setTitle(e.target.value)}
        onKeyDown={(e) => { if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); submit(); } if (e.key === "Escape") onCancel(); }}
        placeholder="Task title…" rows={2} data-testid={`board-add-input-${colName}`}
        className="w-full text-sm bg-transparent outline-none resize-none text-brand-ink" />
      {meta?.office_prop && (
        <select value={office} onChange={(e) => setOffice(e.target.value)} className={sel} data-testid="quick-add-office">
          <option value="">Location{ctx.location ? ` (default: ${ctx.location})` : "…"}</option>
          {offices.map((o) => <option key={o.id} value={o.id}>{o.name}</option>)}
        </select>
      )}
      {meta?.assignee_prop && (
        <select value={person} onChange={(e) => setPerson(e.target.value)} className={sel} data-testid="quick-add-assignee">
          <option value="">Assign to…</option>
          {users.map((u) => <option key={u.id} value={u.id}>{u.name}{u.guest ? " (guest)" : u.hub ? " (hub team)" : ""}</option>)}
        </select>
      )}
      {meta?.due_prop && (
        <label className="flex items-center gap-2 text-[11px] text-brand-tertiary">Due
          <input type="date" value={due} onChange={(e) => setDue(e.target.value)} className={sel} data-testid="quick-add-due" />
        </label>
      )}
      <div className="flex gap-2">
        <button onClick={submit} data-testid={`quick-add-submit-${colName}`} className="text-xs bg-brand-ink text-brand-page rounded px-2 py-1">Add</button>
        <button onClick={onCancel} className="text-xs text-brand-muted">Cancel</button>
      </div>
    </div>
  );
}
